// B2B corp collections (/collections/uniqlo, ...) list several variants of the same
// product (same base title, different price). corp-product-filter.js hides the
// duplicates, but Shopify paginates the unfiltered list, so the hidden cards leave
// short pages and a trailing page that should not exist.
//
// Here we load every page of the collection through the Section Rendering API,
// drop non-matching and duplicate cards across ALL pages (first one wins), then
// re-slice the survivors into pages of `data-per-page` and rebuild the pagination.
// Only runs when window.ShopifyCorpCollection is set (see layout/theme.liquid).
(function () {
  var corp = window.ShopifyCorpCollection;
  var grid = document.getElementById('product-grid');
  var nav = document.querySelector('.pagination__list');
  if (!corp || !grid || !nav) return;

  var sectionId = grid.getAttribute('data-id');
  var perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 16;
  var params = new URLSearchParams(location.search);
  var current = parseInt(params.get('page'), 10) || 1;
  params.delete('page');
  var baseQuery = params.toString();

  var totalServerPages = 1;
  nav.querySelectorAll('li').forEach(function (li) {
    var n = parseInt(li.textContent, 10);
    if (n > totalServerPages) totalServerPages = n;
  });
  if (totalServerPages < 2) return;

  var cacheKey = 'corpgrid:' + location.pathname + '?' + baseQuery;

  function pageUrl(n) {
    var q = new URLSearchParams(baseQuery);
    if (n > 1) q.set('page', n);
    var s = q.toString();
    return location.pathname + (s ? '?' + s : '');
  }

  function fetchPage(n) {
    var q = new URLSearchParams(baseQuery);
    q.set('section_id', sectionId);
    q.set('page', n);
    return fetch(location.pathname + '?' + q.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.map.call(doc.querySelectorAll('#product-grid > li'), function (li) {
          return li.outerHTML;
        });
      });
  }

  function dedupe(lisHtml) {
    var tmp = document.createElement('ul');
    tmp.innerHTML = lisHtml.join('');
    var items = Array.prototype.slice.call(tmp.children);
    var matchCount = items.filter(function (li) {
      var card = li.querySelector('[data-base-title]');
      return card && card.getAttribute('data-corp').indexOf(corp) !== -1;
    }).length;
    // Same safety net as corp-product-filter.js: if nothing matches, our data
    // assumption is wrong - leave the server's pages alone.
    if (matchCount === 0) return null;
    var seen = {};
    return items.filter(function (li) {
      var card = li.querySelector('[data-base-title]');
      if (!card || card.getAttribute('data-corp').indexOf(corp) === -1) return false;
      var base = card.getAttribute('data-base-title');
      if (seen[base]) return false;
      seen[base] = true;
      return true;
    }).map(function (li) { return li.outerHTML; });
  }

  function loadAll() {
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (e) {}
    var jobs = [];
    for (var n = 1; n <= totalServerPages; n++) jobs.push(fetchPage(n));
    return Promise.all(jobs).then(function (pages) {
      var kept = dedupe([].concat.apply([], pages));
      if (kept) {
        try { sessionStorage.setItem(cacheKey, JSON.stringify(kept)); } catch (e) {}
      }
      return kept;
    });
  }

  function pageNumbers(total, cur) {
    var out = [];
    for (var n = 1; n <= total; n++) {
      if (total <= 9 || n === 1 || n === total || Math.abs(n - cur) <= 2) out.push(n);
      else if (out[out.length - 1] !== '…') out.push('…');
    }
    return out;
  }

  function renderNav(total, cur) {
    var prev = nav.firstElementChild.querySelector('a');
    var next = nav.lastElementChild.querySelector('a');
    var wrap = nav.closest('.pagination-wrapper');
    if (total < 2) { if (wrap) wrap.style.display = 'none'; return; }
    function arrow(tpl, n, disabled) {
      var a = tpl.cloneNode(true);
      a.setAttribute('href', pageUrl(n));
      if (disabled) a.setAttribute('disabled', ''); else a.removeAttribute('disabled');
      return '<li>' + a.outerHTML + '</li>';
    }
    var html = arrow(prev, Math.max(1, cur - 1), cur === 1);
    pageNumbers(total, cur).forEach(function (n) {
      if (n === '…') { html += '<li><span class="pagination__item">…</span></li>'; return; }
      html += n === cur
        ? '<li><a role="link" aria-disabled="true" class="pagination__item pagination__item--current light" aria-current="page" aria-label="Page ' + n + '">' + n + '</a></li>'
        : '<li><a href="' + pageUrl(n) + '" class="pagination__item link" aria-label="Page ' + n + '">' + n + '</a></li>';
    });
    html += arrow(next, Math.min(total, cur + 1), cur === total);
    nav.innerHTML = html;
  }

  loadAll().then(function (kept) {
    if (!kept) return;
    var total = Math.max(1, Math.ceil(kept.length / perPage));
    var page = Math.min(Math.max(current, 1), total);
    if (page !== current) history.replaceState(null, '', pageUrl(page));
    grid.innerHTML = kept.slice((page - 1) * perPage, page * perPage).join('');
    renderNav(total, page);
  }).catch(function () { /* keep the server-rendered page as is */ });
})();
